const OnchainFundamentalsIllustration = ({ paused = false }: { paused?: boolean }) => (
  <svg
    width="379"
    height="281"
    viewBox="0 0 379 281"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-auto text-fg-secondary opacity-40"
    style={{ animationPlayState: paused ? "paused" : "running" }}
  >
    <style>
      {`
        @keyframes of-draw {
          0% { stroke-dashoffset: 220; }
          40% { stroke-dashoffset: 0; }
          60% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 220; }
        }
        @keyframes of-scan {
          0%, 40% { opacity: 0; }
          45% { opacity: 0.6; }
          90% { opacity: 0.6; }
          95%, 100% { opacity: 0; }
        }
        .of-chart-line {
          stroke-dasharray: 220;
          stroke-dashoffset: 220;
          animation: of-draw 6s ease-in-out infinite;
          animation-play-state: inherit;
        }
        .of-scan-line {
          animation: of-scan 6s ease-in-out infinite;
          animation-play-state: inherit;
        }
      `}
    </style>

    {/* Browser window frame */}
    <path
      d="M312.422 41.6172H66.237C59.4388 41.6172 53.9277 47.1282 53.9277 53.9264V226.256C53.9277 233.054 59.4388 238.565 66.237 238.565H312.422C319.22 238.565 324.731 233.054 324.731 226.256V53.9264C324.731 47.1282 319.22 41.6172 312.422 41.6172Z"
      stroke="currentColor"
    />

    {/* Window dots */}
    <path
      d="M68 58.6602C69.8392 58.6602 71.3301 57.1693 71.3301 55.3301C71.3301 53.4909 69.8392 52 68 52C66.1609 52 64.6699 53.4909 64.6699 55.3301C64.6699 57.1693 66.1609 58.6602 68 58.6602Z"
      fill="currentColor"
    />
    <path
      d="M79.6543 58.6602C81.4935 58.6602 82.9844 57.1693 82.9844 55.3301C82.9844 53.4909 81.4935 52 79.6543 52C77.8152 52 76.3242 53.4909 76.3242 55.3301C76.3242 57.1693 77.8152 58.6602 79.6543 58.6602Z"
      fill="currentColor"
    />
    <path
      d="M91.3106 58.6602C93.1497 58.6602 94.6407 57.1693 94.6407 55.3301C94.6407 53.4909 93.1497 52 91.3106 52C89.4714 52 87.9805 53.4909 87.9805 55.3301C87.9805 57.1693 89.4714 58.6602 91.3106 58.6602Z"
      fill="currentColor"
    />

    {/* URL bar */}
    <path
      d="M228.824 50H149.836C146.861 50 144.45 52.4112 144.45 55.3856C144.45 58.3599 146.861 60.7711 149.836 60.7711H228.824C231.798 60.7711 234.209 58.3599 234.209 55.3856C234.209 52.4112 231.798 50 228.824 50Z"
      stroke="currentColor"
      strokeWidth="0.729201"
    />

    {/* Left sidebar */}
    <path
      d="M122.63 75H69.7099C66.9264 75 64.6699 77.4746 64.6699 80.5273V221.473C64.6699 224.525 66.9264 227 69.7099 227H122.63C125.413 227 127.67 224.525 127.67 221.473V80.5273C127.67 77.4746 125.413 75 122.63 75Z"
      stroke="currentColor"
    />
    <path
      d="M116.99 84.2383H76.0323C74.7017 84.2383 73.623 85.2456 73.623 86.4883V90.9883C73.623 92.2309 74.7017 93.2383 76.0323 93.2383H116.99C118.32 93.2383 119.399 92.2309 119.399 90.9883V86.4883C119.399 85.2456 118.32 84.2383 116.99 84.2383Z"
      fill="currentColor"
    />
    <path
      d="M109.614 101.473H76.0224C74.6973 101.473 73.623 102.48 73.623 103.723V108.223C73.623 109.465 74.6973 110.473 76.0224 110.473H109.614C110.939 110.473 112.013 109.465 112.013 108.223V103.723C112.013 102.48 110.939 101.473 109.614 101.473Z"
      fill="currentColor"
    />
    <path
      d="M114.531 118.703H76.0294C74.7004 118.703 73.623 119.71 73.623 120.953V125.453C73.623 126.696 74.7004 127.703 76.0294 127.703H114.531C115.86 127.703 116.937 126.696 116.937 125.453V120.953C116.937 119.71 115.86 118.703 114.531 118.703Z"
      fill="currentColor"
    />
    <path
      d="M104.699 135.938H76.0135C74.6933 135.938 73.623 136.945 73.623 138.188V142.688C73.623 143.93 74.6933 144.938 76.0135 144.938H104.699C106.019 144.938 107.089 143.93 107.089 142.688V138.188C107.089 136.945 106.019 135.938 104.699 135.938Z"
      fill="currentColor"
    />
    <path
      d="M112.072 153.168H76.0261C74.6989 153.168 73.623 154.175 73.623 155.418V159.918C73.623 161.161 74.6989 162.168 76.0261 162.168H112.072C113.399 162.168 114.475 161.161 114.475 159.918V155.418C114.475 154.175 113.399 153.168 112.072 153.168Z"
      fill="currentColor"
    />
    <path
      d="M107.156 170.402H76.0183C74.6954 170.402 73.623 171.41 73.623 172.652V177.152C73.623 178.395 74.6954 179.402 76.0183 179.402H107.156C108.479 179.402 109.551 178.395 109.551 177.152V172.652C109.551 171.41 108.479 170.402 107.156 170.402Z"
      fill="currentColor"
    />

    {/* Main chart area */}
    <path
      d="M307.727 75H144.613C141.883 75 139.67 77.4305 139.67 80.4286V164.571C139.67 167.57 141.883 170 144.613 170H307.727C310.457 170 312.67 167.57 312.67 164.571V80.4286C312.67 77.4305 310.457 75 307.727 75Z"
      stroke="currentColor"
    />

    {/* Static chart line (faint base) */}
    <path
      d="M152.402 156.09L177.021 143.781L201.639 149.936L226.258 125.317L250.876 131.472L275.495 113.008L300.113 119.162"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.3"
    />

    {/* Animated chart line (draws on) */}
    <path
      className="of-chart-line"
      d="M152.402 156.09L177.021 143.781L201.639 149.936L226.258 125.317L250.876 131.472L275.495 113.008L300.113 119.162"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Scan line — uses SMIL for SVG-unit-space translation */}
    <g className="of-scan-line" opacity="0">
      <line x1="152" y1="80" x2="152" y2="165" stroke="currentColor" strokeWidth="0.5" />
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0,0;0,0;148,0;148,0"
        keyTimes="0;0.4;0.9;1"
        dur="6s"
        repeatCount="indefinite"
      />
    </g>

    {/* Bottom cards */}
    <path
      d="M187.075 180.562H144.98C142.245 180.562 140.027 183.137 140.027 186.312V220.812C140.027 223.988 142.245 226.562 144.98 226.562H187.075C189.81 226.562 192.027 223.988 192.027 220.812V186.312C192.027 183.137 189.81 180.562 187.075 180.562Z"
      stroke="currentColor"
    />
    <path
      d="M170.866 190.559H148.709C148.03 190.559 147.479 191.11 147.479 191.79V196.713C147.479 197.393 148.03 197.944 148.709 197.944H170.866C171.546 197.944 172.097 197.393 172.097 196.713V191.79C172.097 191.11 171.546 190.559 170.866 190.559Z"
      fill="currentColor"
    />
    <path
      d="M181.945 202.867H149.94C148.581 202.867 147.479 203.969 147.479 205.329V212.715C147.479 214.074 148.581 215.177 149.94 215.177H181.945C183.304 215.177 184.407 214.074 184.407 212.715V205.329C184.407 203.969 183.304 202.867 181.945 202.867Z"
      fill="currentColor"
    />
    <path
      d="M246.17 180.562H204.884C202.202 180.562 200.027 183.137 200.027 186.312V220.812C200.027 223.988 202.202 226.562 204.884 226.562H246.17C248.853 226.562 251.027 223.988 251.027 220.812V186.312C251.027 183.137 248.853 180.562 246.17 180.562Z"
      stroke="currentColor"
    />
    <path
      d="M227.488 190.559H207.793C207.114 190.559 206.562 191.11 206.562 191.79V196.713C206.562 197.393 207.114 197.944 207.793 197.944H227.488C228.168 197.944 228.719 197.393 228.719 196.713V191.79C228.719 191.11 228.168 190.559 227.488 190.559Z"
      fill="currentColor"
    />
    <path
      d="M238.567 202.867H209.024C207.665 202.867 206.562 203.969 206.562 205.329V212.715C206.562 214.074 207.665 215.177 209.024 215.177H238.567C239.927 215.177 241.029 214.074 241.029 212.715V205.329C241.029 203.969 239.927 202.867 238.567 202.867Z"
      fill="currentColor"
    />
    <path
      d="M305.17 180.562H263.884C261.202 180.562 259.027 183.137 259.027 186.312V220.812C259.027 223.988 261.202 226.562 263.884 226.562H305.17C307.853 226.562 310.027 223.988 310.027 220.812V186.312C310.027 183.137 307.853 180.562 305.17 180.562Z"
      stroke="currentColor"
    />
    <path
      d="M293.959 190.559H266.878C266.199 190.559 265.647 191.11 265.647 191.79V196.713C265.647 197.393 266.199 197.944 266.878 197.944H293.959C294.639 197.944 295.19 197.393 295.19 196.713V191.79C295.19 191.11 294.639 190.559 293.959 190.559Z"
      fill="currentColor"
    />
    <path
      d="M295.19 202.867H268.109C266.75 202.867 265.647 203.969 265.647 205.329V212.715C265.647 214.074 266.75 215.177 268.109 215.177H295.19C296.55 215.177 297.652 214.074 297.652 212.715V205.329C297.652 203.969 296.55 202.867 295.19 202.867Z"
      fill="currentColor"
    />
  </svg>
)

export default OnchainFundamentalsIllustration
